import APIClient from '@/shared/http/clients/api'

const resourceName = 'cheque'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name DailyAccountMovementRepository
 * @description Movimentação diária conta
 * @type { Respository }
 */
const DailyAccountMovementRepository = {

  Search
}

export default DailyAccountMovementRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/bankcheck.js